module.exports = __webpack_public_path__ + "img/a.243d369e.png";